import React from 'react';

import { cn } from '@/src/util/ui';

type FormGroupContainerProps = {
  className?: string;
  children: React.ReactNode;
};

const FormGroupContainer = ({ className, children }: FormGroupContainerProps) => {
  return (
    <React.Fragment>
      <div className={cn('formGroup--container', className)}>{children}</div>
    </React.Fragment>
  );
};

export default FormGroupContainer;
